import Box from '@mui/material/Box'
import { useAtomValue, useSetAtom } from 'jotai'
import { debounce } from 'lodash'
import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'

import { fullScreenAtom, isAppContentScrolledDownAtom } from '../../contexts/AtomUtil'

/**
 * AppContent 组件
 * 负责渲染应用的主要内容区域，接收子元素作为内容
 * @param {React.ReactNode} children - 要渲染的子元素（通常是 Routes）
 */
function AppContent({ children }) {
  const setScrolledDown = useSetAtom(isAppContentScrolledDownAtom)
  const fullScreen = useAtomValue(fullScreenAtom)
  const scrollContainerRef = useRef(null)

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current
    if (!scrollContainer) {
      return
    }

    const handleScroll = () => {
      const scrollPosition = scrollContainer.scrollTop
      const lastScrollPosition = scrollContainer.lastScrollPosition || 0

      if (scrollPosition < 80) {
        setScrolledDown(false)
      } else if (scrollPosition > lastScrollPosition) {
        // Scrolling down
        if (scrollPosition - lastScrollPosition > 0) {
          setScrolledDown(true)
        }
      } else {
        // Scrolling up
        if (lastScrollPosition - scrollPosition > 200) {
          setScrolledDown(false)
        }
      }

      scrollContainer.lastScrollPosition = scrollPosition
    }

    const debouncedHandleScroll = debounce(handleScroll, 50)

    scrollContainer.addEventListener('scroll', debouncedHandleScroll)
    return () => {
      scrollContainer.removeEventListener('scroll', debouncedHandleScroll)
    }
  }, [setScrolledDown])

  return (
    <Box
      ref={scrollContainerRef}
      className="hide-scrollbar"
      sx={{
        flex: 1,
        padding: 0,
        paddingTop: fullScreen ? 0 : 7,
        minHeight: 0,
        overflowY: 'auto',
      }}
    >
      {children}
    </Box>
  )
}

AppContent.propTypes = {
  children: PropTypes.node.isRequired,
}

export default AppContent
